import { useMemo } from 'react'
import { useAppSelector } from '@/hooks/useRedux'
import { authSelector } from '@/pages/auth/selectors'
import { userSelector } from '@/pages/user/selectors'
import { useGetClubManagementRoles } from '@/services/club'

export const useHasClubManagementAccess = () => {
  const { token } = useAppSelector(authSelector)
  const { user } = useAppSelector(userSelector)
  const isAuthenticated = !!token && !!user
  const { data: clubRoles, isLoading } = useGetClubManagementRoles(isAuthenticated)

  const hasAccess = useMemo(() => {
    if (!isAuthenticated) return false
    if (!clubRoles?.results) return false

    return clubRoles.results.some((club) => ['DIRECTOR', 'ORGANIZER'].includes(club.role.role))
  }, [isAuthenticated, clubRoles])

  return { hasAccess, isLoading }
}
